import { Link } from "react-router";
import { useSession } from "../../auth/AuthProvider";
import { homeFor } from "../../auth/pages";
import { Card, NotAvailable, PageHeader } from "../../components/ui";
import { PublisherProfileCard } from "../publisher/Profile";
import { OrgTabs } from "./org/orgCopy";

// Screens UX-DESIGN.md specifies whose every action needs endpoints that
// don't exist yet. Each renders the designed structure's headline and a
// precise "not yet available" state — no invented data.

export function OrganizationPage() {
  const { partyType } = useSession();
  const home = homeFor(partyType);
  return (
    <div className="stack-lg">
      <PageHeader title="Organization" description="Your organization's profile, members and roles, pending approvals, audit log and notifications." />
      <OrgTabs home={home} />
      {partyType === "publisher" ? (
        <PublisherProfileCard />
      ) : (
        <Card title="Organization profile">
          <NotAvailable what="The advertiser profile" endpoint="GET/PATCH /v1/advertiser" gapId="G-11" />
        </Card>
      )}
      <Card title="Manage the organization">
        <ul className="stack-sm">
          <li>
            <Link to={`${home}/org/members`}>Members</Link>: roles, invitations, removals and ownership transfer.
          </li>
          <li>
            <Link to={`${home}/org/approvals`}>Pending approvals</Link>: changes waiting for a second member.
          </li>
          <li>
            <Link to={`${home}/org/audit`}>Audit log</Link>: security and financial actions on this account.
          </li>
          <li>
            <Link to={`${home}/org/notifications`}>Notifications</Link>: your inbox.
          </li>
          <li>
            <Link to={`${home}/close-account`}>Close account</Link>: what's left to resolve, a download of your records, and closing.
          </li>
        </ul>
      </Card>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="stack-lg">
      <PageHeader title="Page not found" description="That address doesn't match any page in the portal." />
    </div>
  );
}
